__turbopack_context__.v({
  "danger": "ProfileMenuSections-module-scss-module__SkhyHa__danger",
  "description": "ProfileMenuSections-module-scss-module__SkhyHa__description",
  "icon": "ProfileMenuSections-module-scss-module__SkhyHa__icon",
  "item": "ProfileMenuSections-module-scss-module__SkhyHa__item",
  "items": "ProfileMenuSections-module-scss-module__SkhyHa__items",
  "label": "ProfileMenuSections-module-scss-module__SkhyHa__label",
  "section": "ProfileMenuSections-module-scss-module__SkhyHa__section",
  "text": "ProfileMenuSections-module-scss-module__SkhyHa__text",
});
